exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".el-select[data-v-105e85dc]{width:100%}.footer[data-v-105e85dc]{width:100%;position:absolute;top:0;text-align:right;padding-right:20px;margin-top:10px}", "", {"version":3,"sources":["/home/www/deploy/school/src/views/oa_catalog/add-form.vue"],"names":[],"mappings":"AACA,4BACE,UAAY,CACb,AACD,yBACE,WAAY,AACZ,kBAAmB,AACnB,MAAO,AACP,iBAAkB,AAClB,mBAAoB,AACpB,eAAiB,CAClB","file":"add-form.vue","sourcesContent":["\n.el-select[data-v-105e85dc] {\n  width: 100%;\n}\n.footer[data-v-105e85dc] {\n  width: 100%;\n  position: absolute;\n  top: 0;\n  text-align: right;\n  padding-right: 20px;\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-105e85dc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/oa_catalog/add-form.vue
// module id = azFU
// module chunks = 28